export default __webpack_public_path__ + "static/media/ponentes___FedericoLopez.0214db51.jpg";